import {Option} from "ts-option";
import {BooleanFilter} from "./BooleanFilter";

export class BooleanStatusFilter extends BooleanFilter {

	getFilterValue(): string {
		return (this.props.filter.values as Option<boolean>).map(
			v => v == true ? BooleanStatusEnum.Disabled : BooleanStatusEnum.Active).orNull
	}

	itemToLabel(item: boolean): string {
		return item ? BooleanStatusEnum.Disabled : BooleanStatusEnum.Active;
	}
}

export enum BooleanStatusEnum {
	Active = "Active",
	Disabled = "Disabled"
}
